export const CHAT_HISTORY_WIDTH_TRANSITION_CLASS =
  "transition-[width] duration-200 ease-in-out";

/** Must match the duration in CHAT_HISTORY_WIDTH_TRANSITION_CLASS. */
export const AFTER_CHAT_HISTORY_TRANSITION_DELAY_CLASS = "delay-200";
